import { Component, ElementRef, inject, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationSkipped, NavigationStart, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { filter } from 'rxjs';
import { AttributeHandlerService } from 'services/attribute-handler.service';

const INERT_OVERLAY_ELEMENTS = ['main', 'footer'];

@Component({
  selector: 'app-navmenu',
  templateUrl: './navmenu.component.html',
  styleUrl: './navmenu.component.scss',
  imports: [RouterModule, FontAwesomeModule, CommonModule]
})
export class NavmenuComponent {
  navmenuContent = viewChild.required<ElementRef>('navmenuContent');
  menuButton = viewChild.required<ElementRef>('menuButton');
  homeLink = viewChild.required<ElementRef>('homeLink');

  faBars = faBars;
  isOverlayOpen = false;

  private readonly router = inject(Router);

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart || event instanceof NavigationSkipped))
      .forEach(() => {
        this.toggleOverlay('close');
      });
  }

  toggleMenu() {
    this.toggleOverlay();

    setTimeout(() => {
      AttributeHandlerService.forElement(this.homeLink().nativeElement).setFocus(this.isOverlayOpen);
      AttributeHandlerService.forElement(this.menuButton().nativeElement).setFocus(!this.isOverlayOpen);
    });
  }

  private toggleOverlay(overrideAction?: 'open' | 'close') {
    // I opted not to inline this logic to make it easily readable.
    if (overrideAction === 'open') {
      this.isOverlayOpen = true;
    } else if (overrideAction === 'close') {
      this.isOverlayOpen = false;
    } else {
      // If overrideAction is provided, use it otherwise, toggle it to the opposite state.
      this.isOverlayOpen = !this.isOverlayOpen;
    }

    INERT_OVERLAY_ELEMENTS.map(selector => document.querySelector(selector))
      .filter(el => el !== null)
      .forEach(el => {
        // prettier-ignore
        AttributeHandlerService.forElement(el as HTMLElement)
          .setInert(this.isOverlayOpen)
          .setAriaHidden(this.isOverlayOpen);
      });
  }
}
